import app from "flarum/forum/app";
import UserPage from "flarum/forum/components/UserPage";
import PageStructure from "flarum/forum/components/PageStructure";
import Placeholder from "flarum/common/components/Placeholder";
import Button from "flarum/common/components/Button";
export function restrictedView(page) {
  const membersOnly = page.user?.attribute("effectiveProfileVisibility") === "members";
  return m(PageStructure, {
    className: "UserPage UserPage--private",
    loading: !page.user,
    hero: page.hero.bind(page),
    sidebar: page.sidebar.bind(page)
  }, m("div", {
    className: "PrivateProfile-message"
  }, m(Placeholder, {
    text: app.translator.trans(`huseyinfiliz-private-profile.forum.${membersOnly ? "profile_members_only" : "profile_is_private"}`)
  }), membersOnly && !app.session.user && m(Button, {
    className: "Button Button--primary",
    onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
  }, app.translator.trans("core.forum.header.log_in_link"))));
}
export default class RestrictedProfilePage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param("username"));
  }
  view() {
    return restrictedView(this);
  }
}
flarum.reg.add('huseyinfiliz-private-profile', 'forum/components/RestrictedProfilePage', RestrictedProfilePage);